import React from 'react';

export default function ReadRecoveryNotice({ reads }) {
  const statuses = reads.flatMap(read => read.statuses);
  if (!statuses.length) return null;
  const reconnecting = statuses.includes('reconnecting');
  return (
    <div role="status" aria-live="polite" className="sticky top-0 z-50 mb-3 rounded-lg border border-amber-400 bg-amber-50 px-4 py-3 text-amber-950 shadow-sm">
      <strong>{reconnecting ? 'Reconectando…' : 'No se pudieron actualizar los datos.'}</strong>{' '}
      {reconnecting ? 'Volveremos a consultar automáticamente. Los datos visibles pueden estar desactualizados.' : 'Revisá tu sesión y volvé a abrir esta pantalla. Los datos visibles pueden estar desactualizados.'}
    </div>
  );
}
